"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIDtoFactory = void 0;
var class_transformer_1 = require("class-transformer");
var dto_1 = require("../dto");
var enums_1 = require("../enums");
var AuthModels = __importStar(require("../models/auth"));
var SharedModels = __importStar(require("../models/shared"));
var TenantModels = __importStar(require("../models/tenants"));
var UIModels = __importStar(require("../models/ui"));
var UserModels = __importStar(require("../models/users"));
var TENANT_CREATION = enums_1.UiDtoFactoryEnum.TENANT_CREATION, UNIFIED_ROLE_COLLECTION = enums_1.UiDtoFactoryEnum.UNIFIED_ROLE_COLLECTION, TENANT = enums_1.UiDtoFactoryEnum.TENANT, TENANT_CREDENTIALS = enums_1.UiDtoFactoryEnum.TENANT_CREDENTIALS, TENANT_PATCH = enums_1.UiDtoFactoryEnum.TENANT_PATCH, TENANT_PRODUCT_COLLECTION = enums_1.UiDtoFactoryEnum.TENANT_PRODUCT_COLLECTION, TENANT_PROPERTY_COLLECTION = enums_1.UiDtoFactoryEnum.TENANT_PROPERTY_COLLECTION, USER_PERMISSIONS = enums_1.UiDtoFactoryEnum.USER_PERMISSIONS, TENANT_QUERY = enums_1.UiDtoFactoryEnum.TENANT_QUERY, TENANT_QUERY_RESULTS = enums_1.UiDtoFactoryEnum.TENANT_QUERY_RESULTS, TENANT_RESOURCE_IDENTIFIER = enums_1.UiDtoFactoryEnum.TENANT_RESOURCE_IDENTIFIER, TENANT_ADMIN_USER_QUERY = enums_1.UiDtoFactoryEnum.TENANT_ADMIN_USER_QUERY, TENANT_STATUS_IDENTIFIER = enums_1.UiDtoFactoryEnum.TENANT_STATUS_IDENTIFIER, USER_LOGOUT_ACTIONS = enums_1.UiDtoFactoryEnum.USER_LOGOUT_ACTIONS, USER_PATCH = enums_1.UiDtoFactoryEnum.USER_PATCH, USER_CREATION = enums_1.UiDtoFactoryEnum.USER_CREATION, USER = enums_1.UiDtoFactoryEnum.USER, P44_ADMIN_GET_USER_BY_ID_QUERY = enums_1.UiDtoFactoryEnum.P44_ADMIN_GET_USER_BY_ID_QUERY, TENANT_ADMIN_GET_USER_BY_ID_QUERY = enums_1.UiDtoFactoryEnum.TENANT_ADMIN_GET_USER_BY_ID_QUERY, USER_RESOURCE_IDENTIFIER = enums_1.UiDtoFactoryEnum.USER_RESOURCE_IDENTIFIER, VOID_RESPONSE = enums_1.UiDtoFactoryEnum.VOID_RESPONSE, USER_QUERY_RESULTS = enums_1.UiDtoFactoryEnum.USER_QUERY_RESULTS, P44_ADMIN_USER_QUERY = enums_1.UiDtoFactoryEnum.P44_ADMIN_USER_QUERY, UI_ONLY_P44_ADMIN_ACCESS_LEVEL_USER_MODEL = enums_1.UiDtoFactoryEnum.UI_ONLY_P44_ADMIN_ACCESS_LEVEL_USER_MODEL, UI_ONLY_TENANT_ADMIN_ACCESS_LEVEL_USER_MODEL = enums_1.UiDtoFactoryEnum.UI_ONLY_TENANT_ADMIN_ACCESS_LEVEL_USER_MODEL, AUTHENTICATION_RESPONSE = enums_1.UiDtoFactoryEnum.AUTHENTICATION_RESPONSE, MOVE_USER_TENANT = enums_1.UiDtoFactoryEnum.MOVE_USER_TENANT, USER_RESET_EMAIL_REQUEST = enums_1.UiDtoFactoryEnum.USER_RESET_EMAIL_REQUEST;
var UIDtoFactory = /** @class */ (function () {
    function UIDtoFactory() {
    }
    UIDtoFactory.uiSpecificModelsDtoMap = (_a = {},
        _a[UI_ONLY_P44_ADMIN_ACCESS_LEVEL_USER_MODEL] = UIModels.P44AdminAccessLevelUserModelViewModel,
        _a[UI_ONLY_TENANT_ADMIN_ACCESS_LEVEL_USER_MODEL] = UIModels.TenantAdminAccessLevelUserModelViewModel,
        _a);
    UIDtoFactory.authModelsDtoMap = (_b = {},
        _b[USER_LOGOUT_ACTIONS] = AuthModels.UserLogOutActionsCollectionViewModel,
        _b[AUTHENTICATION_RESPONSE] = AuthModels.AuthenticationResponseViewModel,
        _b);
    UIDtoFactory.sharedModelsDtoMap = (_c = {},
        _c[TENANT_CREATION] = SharedModels.TenantCreationViewModel,
        _c[UNIFIED_ROLE_COLLECTION] = SharedModels.UnifiedRoleCollectionViewModel,
        _c[VOID_RESPONSE] = SharedModels.VoidResponseViewModel,
        _c);
    UIDtoFactory.tenantModelsDtoMap = (_d = {},
        _d[TENANT] = TenantModels.TenantViewModel,
        _d[TENANT_CREDENTIALS] = TenantModels.TenantCredentialsViewModel,
        _d[TENANT_PATCH] = TenantModels.TenantPatchViewModel,
        _d[TENANT_PRODUCT_COLLECTION] = TenantModels.TenantProductCollectionViewModel,
        _d[TENANT_PROPERTY_COLLECTION] = TenantModels.TenantPropertyCollectionViewModel,
        _d[TENANT_QUERY] = TenantModels.TenantQueryViewModel,
        _d[TENANT_QUERY_RESULTS] = TenantModels.TenantQueryResultsViewModel,
        _d[TENANT_STATUS_IDENTIFIER] = TenantModels.TenantStatusQueryViewModel,
        _d[TENANT_RESOURCE_IDENTIFIER] = TenantModels.TenantResourceIdentifierViewModel,
        _d);
    UIDtoFactory.userModelsDtoMap = (_e = {},
        _e[P44_ADMIN_GET_USER_BY_ID_QUERY] = UserModels.P44AdminsGetUserByIdQueryParamsViewModel,
        _e[P44_ADMIN_USER_QUERY] = UserModels.P44AdminsUserQueryViewModel,
        _e[TENANT_ADMIN_GET_USER_BY_ID_QUERY] = UserModels.TenantAdminsGetUserByIdQueryParamsViewModel,
        _e[TENANT_ADMIN_USER_QUERY] = UserModels.TenantAdminsUserQueryViewModel,
        _e[USER] = UserModels.UserViewModel,
        _e[USER_CREATION] = UserModels.UserCreationViewModel,
        _e[USER_PATCH] = UserModels.UserPatchViewModel,
        _e[USER_QUERY_RESULTS] = UserModels.UserQueryResultsViewModel,
        _e[USER_RESOURCE_IDENTIFIER] = UserModels.UserResourceIdentifierViewModel,
        _e[USER_PERMISSIONS] = UserModels.UserPermissionsCollectionViewModel,
        _e[MOVE_USER_TENANT] = UserModels.MoveUserTenantViewModel,
        _e[USER_RESET_EMAIL_REQUEST] = UserModels.UserResetEmailRequestViewModel,
        _e);
    UIDtoFactory.dtoMap = __assign(__assign(__assign(__assign(__assign({}, UIDtoFactory.authModelsDtoMap), UIDtoFactory.sharedModelsDtoMap), UIDtoFactory.tenantModelsDtoMap), UIDtoFactory.userModelsDtoMap), UIDtoFactory.uiSpecificModelsDtoMap);
    UIDtoFactory.create = function (type, payload) {
        return new dto_1.DtoBase({
            model: (0, class_transformer_1.plainToInstance)((UIDtoFactory.dtoMap[type]), payload, {
                excludeExtraneousValues: true,
                exposeDefaultValues: true,
                enableImplicitConversion: true,
            }),
        });
    };
    return UIDtoFactory;
}());
exports.UIDtoFactory = UIDtoFactory;
